export const opacity = {
    default: '1',
    disabled: '0.64',
    underlay: '0.48',
    faded: '0.64',
};
//# sourceMappingURL=opacity.js.map